var class2type = (function () {
  var class2type = {};
  var arr = "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ");
  arr.forEach(function (name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });
  return class2type;
})();

var _type = function (obj) {
  if (obj == null) {
    return obj + "";
  }
  return typeof obj === "object" || typeof obj === "function" ?
    class2type[{}.toString.call(obj)] || "object" :
    typeof obj;
};

var isArray = Array.isArray;

var isFunction = function (obj) {
  return _type(obj) === "function";
};

var isPlainObject = function (obj) {
  return _type(obj) === 'object';
};

var extend = function () {
  var src, copyIsArray, copy, name, options, clone,
    target = arguments[0] || {},
    i = 1,
    length = arguments.length,
    deep = false;

  // Handle a deep copy situation
  if (typeof target === "boolean") {
    deep = target;

    // skip the boolean and the target
    target = arguments[i] || {};
    i++;
  }

  // Handle case when target is a string or something (possible in deep copy)
  if (typeof target !== "object" && !isFunction(target)) {
    target = {};
  }

  // extend jQuery itself if only one argument is passed
  if (i === length) {
    target = this;
    i--;
  }

  for (; i < length; i++) {

    // Only deal with non-null/undefined values
    if ((options = arguments[i]) != null) {

      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name];

        // Prevent never-ending loop
        if (target === copy) {
          continue;
        }

        // Recurse if we're merging plain objects or arrays
        if (deep && copy && (isPlainObject(copy) ||
          (copyIsArray = isArray(copy)))) {

          if (copyIsArray) {
            copyIsArray = false;
            clone = src && isArray(src) ? src : [];

          } else {
            clone = src && isPlainObject(src) ? src : {};
          }

          // Never move original objects, clone them
          target[name] = extend(deep, clone, copy);

          // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  // Return the modified object
  return target;
};

var each = function (obj, callback) {
  var length, i = 0;

  if (isArray(obj)) {
    length = obj.length;
    for (; i < length; i++) {
      if (callback.call(obj[i], i, obj[i]) === false) {
        break;
      }
    }
  } else {
    for (i in obj) {
      if (callback.call(obj[i], i, obj[i]) === false) {
        break;
      }
    }
  }

  return obj;
};

// ajax请求
var param = function (obj) {
  var list = [];
  var isEncode = arguments.length > 1 && arguments[1] == false ? 'false' : 'true';
  for (var key in obj) {
    var value = obj[key];
    value = value == null ? '' : value;
    if (isEncode === 'false') {
      list[list.length] = key + '=' + value;
    } else {
      list[list.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }
  }
  var r20 = /%20/g;
  return list.join('&').replace(r20, '+');
};

/**
 * 实现类与类之间的继承。
 * @method inherits
 * @grammar Base.inherits( super ) => child
 * @grammar Base.inherits( super, protos ) => child
 * @grammar Base.inherits( super, protos, statics ) => child
 * @param  {Class} super 父类
 * @param  {Object | Function} [protos] 子类或者对象。如果对象中包含constructor，子类将是用此属性值。
 * @param  {Function} [protos.constructor] 子类构造器，不指定的话将创建个临时的直接执行父类构造器的方法。
 * @param  {Object} [statics] 静态属性或方法。
 * @return {Class} 返回子类。
 * @example
 * function Person() {
     *     console.log( 'Super' );
     * }
 * Person.prototype.hello = function() {
     *     console.log( 'hello' );
     * };
 *
 * var Manager = Base.inherits( Person, {
     *     world: function() {
     *         console.log( 'World' );
     *     }
     * });
 *
 * // 因为没有指定构造器，父类的构造器将会执行。
 * var instance = new Manager();    // => Super
 *
 * // 继承子父类的方法
 * instance.hello();    // => hello
 * instance.world();    // => World
 *
 * // 子类的__super__属性指向父类
 * console.log( Manager.__super__ === Person );    // => true
 */
var inherits = function (Super, protos, staticProtos) {
  var child;

  if (typeof protos === 'function') {
    child = protos;
    protos = null;
  } else if (protos && protos.hasOwnProperty('constructor')) {
    child = protos.constructor;
  } else {
    child = function () {
      return Super.apply(this, arguments);
    };
  }

  // 复制静态方法
  extend(child, Super, staticProtos || {});

  // 让子类的__super__属性指向父类。
  child.__super__ = Super.prototype;

  // 构建原型，添加原型方法或属性。
  child.prototype = Object.create(Super.prototype);
  child.prototype._super = Super;
  protos && extend(true, child.prototype, protos);

  return child;
};

var urlConvert = function (url) {
  if (!url || typeof url !== 'string') {
    return url;
  }
  var convert_url = url;
  if (url.indexOf('https:') > -1) {
    convert_url = url.substr(6);
  } else if (url.indexOf('http:') > -1) {
    convert_url = url.substr(5);
  } else if (url.indexOf('//') === 0) {
    convert_url = url;
  }
  return convert_url;
};

/*string转换为number,进行比较*/
var strToNumCompare = function (str1, str2) {
  var result = 0;
  var nagative;
  if (!str1 && !str2) {
    return result;
  }
  if (isNaN(str1) || isNaN(str2)) {
    return null;
  }

  str1 = str1 + '';
  str2 = str2 + '';
  // 负数
  if (str1.charAt(0) == '-' && str2.charAt(0) != '-') {
    result = -1;
    return result;
  } else if (str1.charAt(0) != '-' && str2.charAt(0) == '-') {
    result = 1;
    return result;
  }
  if (str1.charAt(0) == '-' && str2.charAt(0) == '-') {
    str1 = str1.substring(1);
    str2 = str2.substring(1);
    nagative = true;
  }
  var len1 = str1.length;
  var len2 = str2.length;
  if (len1 > len2) {
    result = 1;
  } else if (len1 < len2) {
    result = -1;
  } else if (len1 == len2) {
    for (var i = 0; i < len1; i++) {
      if (str1[i] > str2[i]) {
        result = 1;
        break;
      } else if (str1[i] < str2[i]) {
        result = -1;
        break;
      } else if (str1[i] == str2[i]) {
        continue;
      }
    }
  }

  if (nagative) {
    result = result == 1 ? -1 : result == -1 ? 1 : 0;
  }
  return result;
};

var onloadTimer = null;
var ONLOAD_TIMEOUT = 1e4;
var onload = function (cb) {
  if (document.readyState === 'complete') {
    cb && cb();
  } else {
    // 防止业务方代码问题导致无法onload的情况
    onloadTimer = setTimeout(function () {
      console.log('timeout');
      onloadTimer = null;
      cb && cb();
    }, ONLOAD_TIMEOUT);

    $(window).load(function () {
      console.log('onload');
      if (onloadTimer) {
        clearTimeout(onloadTimer);
        cb && cb();
      }
    });
  }
};

var jsonHandler = {};
jsonHandler.parse = function (data) {
  try {
    data = JSON.parse(data);
  } catch (e) {
    data = {};
  }
  return data;
};
jsonHandler.stringify = function (data) {
  try {
    data = JSON.stringify(data);
  } catch (e) {
    data = '';
  }
  return data;
};

var asynchPipe = (function(){
  var pipe = function(fun){
    this.row = [];
    this.options = {
      status: 0,
      index: 0
    };
    var resolve = this.resolve.bind(this);
    var reject = this.reject.bind(this);
    fun && fun(resolve, reject);
  };
  pipe.prototype.of = function(){
    var _this = this;
    var _pipe = new pipe();
    _pipe.row = this.row;
    _pipe.options = {
      status: 0,
      index: 0
    };
    return _pipe;
  };
  pipe.prototype.resolve = function(){
    if(this.options.status == 3)return;
    var _arguments = Array.prototype.slice.apply(arguments);
    this.options.status = 1;
    this.resolve_val = _arguments;
    if(this.options.index >= this.row.length)return;
    this.options.status = 3;
    var _this = this.row[this.options.index];
    if(_this && _this.success.apply(_this, _arguments));
  };
  pipe.prototype.reject = function(val){
    if(this.options.status == 3)return;
    var _arguments = Array.prototype.slice.apply(arguments);
    this.options.status = 2;
    this.reject_val = _arguments;
    if(this.options.index >= this.row.length)return;
    this.options.status = 3;
    var _this = this.row[this.options.index];
    if(_this && _this.fail.apply(_this, _arguments));
  };
  pipe.prototype.then = function(success, fail) {
    var _pipe = this.of(success, fail);
    _pipe.options.index = this.options.index + 1;
    _pipe.success = success;
    _pipe.fail = fail;
    this.row.push(_pipe);
    if(this.options.status == 1){
      _pipe.success.apply(_pipe, this.resolve_val);
    }else if(this.options.status == 2){
      _pipe.fail.apply(_pipe, this.reject_val);
    }
    return _pipe;
  };
  return pipe;
})();


var fnEmpty = function () {
};

var isEmpty = function (input) {
  return input + '' === 'null' || input + '' === 'undefined' || input === '';
};

var toString = function (data) {
  return !!data ? data + '' : '';
};

module.exports = {
  extend: extend,
  each: each,
  param: param,
  inherits: inherits,
  urlConvert: urlConvert,
  fnEmpty: fnEmpty,
  toString: toString,
  onload: onload,
  isEmpty: isEmpty,
  jsonHandler: jsonHandler,
  strToNumCompare: strToNumCompare,
  asynchPipe: asynchPipe
};
